<template>
  <span class="tooltip-toggle" :aria-label=text tabindex="0">
    <span class="icon icon-info"></span>
<!--    <slot name="text"></slot>-->

  </span>
</template>

<script>
export default {
  name: "Tooltip",
  props: ["text"],
  data() {
    return {

    }
  },
  computed: {
    formattedText: {
      get() {
        return this.text.replace(/(?:\r\n|\r|\n)/g, '<br>');
      }
    },
  }
}
</script>

<style scoped lang="scss">
.tooltip-toggle {
  cursor: pointer;
  position: static;

  @include sm {
    position: static;
  }

  @include md {
    position: relative;
  }

  &:focus,
  &:active {
    outline: none;
  }

  .icon {
    font-size: 1rem;
    margin-left: .5rem;
  }
  //Tooltip text container
  &::before {
    position: absolute;
    //top: 1.5rem;
    //left: -150px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #CAD4DD;
    border-radius: 5px;
    border: 1px solid $border;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    content: attr(aria-label); //This pulls in the text from the element with the tooltip
    padding: 1rem;
    text-transform: none;
    transition: all 0.5s ease;
    width: 300px;
    z-index: 99999;
    font-weight: $font-weight-regular;

    @include sm {
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }

    @include md {
      top: 50%;
      left: 50%;
      transform: translate(0,-50%);
    }

    @include lg {
      top: 1.5rem;
      transform: none;
      left: -200px;
    }

    @include rwd(992) {
      left: -200px;
    }

    @include rwd(1096) {
      top: 1.5rem;
      left: -150px;
    }
    @include rwd(1500) {
      top: -1rem;
      left: 2rem;
    }
  }

  //Tooltip arrow
  // &::after {
  //   position: absolute;
  //   top: -12px;
  //   left: 9px;
  //   border-left: 5px solid transparent;
  //   border-right: 5px solid transparent;
  //   border-top: 5px solid $gray;
  //   content: " ";
  //   font-size: 0;
  //   line-height: 0;
  //   margin-left: -5px;
  //   width: 0;
  // }

  //Setting up the transition
  &::before,
  &::after {
    color: $color-text-gray;
    font-size: $font-size-xs;
    font-weight: $font-weight-regular;
    opacity: 0;
    pointer-events: none;
    //text-align: center;
  }

  //Triggering the transition
  &:focus::before,
  &:focus::after,
  &:hover::before,
  &:hover::after {
    opacity: 1;
    transition: all 0.75s ease;
  }
}

</style>
